import { ThemeUIStyleObject } from 'theme-ui';
import { focusOutline, spacing } from '../util';
import getColorsByPath from './colors/util/getColorsByPath';

export const alerts: Record<string, ThemeUIStyleObject> = {
  primary: {
    border: '1px solid',
    borderLeft: '12px solid',
    borderRadius: 'alerts',

    display: 'flex',
    flexDirection: 'column',
    fontWeight: 'normal',

    maxHeight: '60vh',
    overflow: 'auto',
    overflowX: 'hidden',
    p: 0,

    '&:focus': {
      outline: 'none',
    },

    '.notification__header': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'sticky',
      top: 0,
      width: '100%',
      p: spacing(5),
    },

    '.notification__title': {
      fontSize: 18,
      fontWeight: 'bold',
      color: 'palette.text.primary',
      display: 'flex',
      gap: spacing(5),
      alignItems: 'center',
    },

    '.notification__closeButton': {
      flexShrink: 0,
    },

    '.notification__body': {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      gap: spacing(5),
      width: '100%',
      p: spacing(5),
    },

    '.notification__header ~ .notification__body': {
      pt: 0,
    },

    '.notification__content': {
      display: 'flex',
      alignItems: 'stretch',
      flexDirection: 'column',
      gap: spacing(5),
      width: '100%',
    },

    '.notification__icon': {
      flexShrink: 0,
      height: 'iconMd',
      svg: {
        height: 'iconMd',
        width: 'iconMd',
      },
    },

    '.notification__message': {
      display: 'flex',
      flexDirection: 'column',
      fontWeight: 'normal',
      gap: spacing(3),
      width: '100%',
      wordBreak: 'break-word',

      ul: {
        listStyle: 'disc',
        ml: '20px',
      },
    },

    '.notification__trace': {
      maxWidth: '100%',
      overflow: 'hidden',
      maxHeight: '30vh',
      flexShrink: 0,
      backgroundColor: 'rgba(10,10,10,0.02)',
      pt: spacing(5),
      display: 'flex',
      flexDirection: 'column',

      '.notification__traceLabel': {
        pl: spacing(5),
        display: 'flex',
        gap: 2,
      },
      '.notification__traceText': {
        fontWeight: 'normal',
        p: spacing(5),
        maxHeight: '30vh',
        overflow: 'auto',
        maxWidth: '100%',
        position: 'relative',
      },
    },

    '&:focus .notification__closeButton': focusOutline,
  },
  warning: {
    variant: 'alerts.primary',

    '&, & .notification__header': {
      ...getColorsByPath('notifications.warning'),
    },
  },
  danger: {
    variant: 'alerts.primary',
    '&, & .notification__header': {
      ...getColorsByPath('notifications.error'),
    },
  },
  success: {
    variant: 'alerts.primary',
    '&, & .notification__header': {
      ...getColorsByPath('notifications.success'),
    },
  },
  info: {
    variant: 'alerts.primary',
    '&, & .notification__header': {
      ...getColorsByPath('notifications.info'),
    },
  },
};
